<div class="lg-menu" [class.payment-failed]="failedPayment">
  <div>
    <a
      [routerLink]="['installation']"
      routerLinkActive="active-link"
      class="router-link">
      {{'LEAD_GENERATION.LEFT_MENU.INSTALL' | translate}}
    </a>
    <a
      [routerLink]="['settings']"
      routerLinkActive="active-link"
      class="router-link"
      href="/settings">
      {{'LEAD_GENERATION.LEFT_MENU.SETTINGS' | translate}}
    </a>
<!--    <a-->
<!--      [routerLink]="['creator', creatorPageForActiveType]"-->
<!--      href="{{'/creator'+creatorPageForActiveType}}"-->
<!--      routerLinkActive="active-link"-->
<!--      class="router-link desktop-only"-->
<!--      [ngClass]="{ 'disabled-link': isCreatingNewProject }">-->
<!--      <a [routerLink]="['creator', 'select']"></a>-->
<!--      <a [routerLink]="['creator', 'popup']"></a>-->
<!--      <a [routerLink]="['creator', 'bubble']"></a>-->
<!--      <span>{{'LEAD_GENERATION.LEFT_MENU.CREATOR' | translate}}</span>-->
<!--    </a>-->
    <a
      [routerLink]="['creator', 'bubble']"
      href="/creator/bubble"
      routerLinkActive="active-link"
      class="router-link desktop-only">
<!--      [ngClass]="{ 'disabled-link': isCreatingNewProject }">-->
<!--      <a [routerLink]="['creator', 'select']"></a>-->
<!--      <a [routerLink]="['creator', 'popup']"></a>-->
      <a [routerLink]="['creator', 'bubble']"></a>
      <span>{{'LEAD_GENERATION.LEFT_MENU.CREATOR' | translate}}</span>
    </a>
  </div>
</div>
<div class="lg-app-container lg-responsive-container" [class.payment-failed]="failedPayment">
  <router-outlet></router-outlet>
</div>
